import React, { useEffect } from 'react';

import { bemCssModules, getTestId } from '@utils';
import { SchemesEnum } from '@utils/types';

import { globalActions, useStore } from '@modules';

import Moon from './moon.svg';
import Sun from './sun.svg';

import style from './SchemeSwitcher.scss';

const cn = bemCssModules(style, 'SchemeSwitcher');
const ti = getTestId('SchemeSwitcher');

export const SchemeSwitcher: CustomFC = ({ className }) => {
  const [{ global }, dispatch] = useStore();
  const { scheme } = global;

  const handleSwitchScheme = () => {
    const newScheme = scheme === SchemesEnum.dark ? SchemesEnum.light : SchemesEnum.dark;
    dispatch(globalActions.setScheme(newScheme));
  };

  return (
    <button
      className={cn(null, [className])}
      type="button"
      data-testid={ti()}
      onClick={handleSwitchScheme}
    >
      {scheme === SchemesEnum.dark ? (
        <Sun data-testid={ti('sun')} />
      ) : (
        <Moon data-testid={ti('moon')} />
      )}
    </button>
  );
};

export default SchemeSwitcher;
